import React from 'react';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import CsvAdmin from './CsvAdmin/CsvAdmin';
import CampaignAdmin from './CampaignAdmin/CampaignAdmin';

const RefillsPage = () => {
  return (
    <PageContainer>
      <CsvAdmin />
      <CampaignAdmin />
    </PageContainer>
  );
};

export default RefillsPage;
